module.exports = __webpack_public_path__ + "static/img/video-cover.6eeb1659.png";